import { RestServiceConnection } from '../restServiceConnection';

const ENDPOINT = '/documents';

export class DocumentsService extends RestServiceConnection {

    //--------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTENER DOCUMENTO POR ID
     * @EN GET DOCUMENT BY ID
     * 
     * @param documentId
     */
    //--------------------------------------------------------------------------------------------------------
    renderDocument = async (document: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            responseType: 'blob',
            url: ENDPOINT + '/render',
            data: { id: document },
            headers: {
                "Content-Type": "application/json",
                "responseType": "blob"
            }
        }, true);
        return this;
    }
    //--------------------------------------------------------------------------------------------------------


    //--------------------------------------------------------------------------------------------------------
    /**
     * @ES SUBIR VARIOS DOCUMENTOS
     * @EN UPLOAD MULTIPLE DOCUMENTS
     * 
     * @param entityId
     * @param entityName
     * @param documents
     * @param documentTypeId
     */
    //--------------------------------------------------------------------------------------------------------
    uploadDocuments = async (entityId: string, entityName: string, documents: File[], documentTypeId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/upload',
            data: {
                entityId,
                entityName,
                documents,
                documentTypeId,
            },
            headers: { "Content-Type": "multipart/form-data" }
        }, true);
        return this;
    }
    //--------------------------------------------------------------------------------------------------------


    //--------------------------------------------------------------------------------------------------------
    /**
     * @ES DESCARGAR DOCUMENTO
     * @EN DOWNLOAD DOCUMENT
     * 
     * @param documentId
     */
    //--------------------------------------------------------------------------------------------------------
    downloadDocument = async (documentId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/download',
            data: { 
                id: documentId 
            },
            responseType: 'blob'
        }, true);
        return this;
    }
    //--------------------------------------------------------------------------------------------------------


    //--------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINAR VARIOS DOCUMENTOS
     * @EN DELETE MULTIPLE DOCUMENTS
     * 
     * @param documentIds
     */
    //--------------------------------------------------------------------------------------------------------
    multiDeleteDocuments = async (documentIds: string[]) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete-multi',
            data: { ids: documentIds },
        }, true);
        return this;
    }
    //--------------------------------------------------------------------------------------------------------


    //--------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTENER DOCUMENTOS
     * @EN GET DOCUMENTS
     * 
     * @param filters
     */
    //--------------------------------------------------------------------------------------------------------
    listDocuments = async (filters: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list',
            data: filters,
        }, true);
        return this;
    }
    //--------------------------------------------------------------------------------------------------------


    //--------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTENER DOCUMENTOS POR ID
     * @EN GET DOCUMENTS BY ID
     * 
     * @param documentId
     */
    //--------------------------------------------------------------------------------------------------------
    getDocumentById = async (documentId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/get',
            data: { id: documentId },
        }, true);
        return this;
    }
    //--------------------------------------------------------------------------------------------------------

        //--------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTENER DOCUMENTOS POR ID
     * @EN GET DOCUMENTS BY ID
     * 
     * @param documentId
     */
    //--------------------------------------------------------------------------------------------------------
    uploadUserHasDocument = async (values: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/create',
            data: values,
            headers: { "Content-Type": "multipart/form-data" }
        }, true);
        return this;
    }
    //--------------------------------------------------------------------------------------------------------

    //--------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTENER TIPOS DE DOCUMENTOS
     * @EN GET DOCUMENT TYPES
     * 
     * @param filters
     */
    //--------------------------------------------------------------------------------------------------------
    listDocumentTypes = async (filters: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list-types',
            data: filters,
        }, true);
        return this;
    }
    //--------------------------------------------------------------------------------------------------------
    

    //--------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTENER ESTADOS DE DOCUMENTOS
     * @EN GET DOCUMENT STATUS
     * 
     * @param filters
     */
    //--------------------------------------------------------------------------------------------------------
    listDocumentStatus = async (filters: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list-status',
            data: filters,
        }, true);
        return this;
    }
    //--------------------------------------------------------------------------------------------------------


    //--------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINAR DOCUMENTO
     * @EN DELETE DOCUMENT
     * 
     * @param id
     */
    //--------------------------------------------------------------------------------------------------------
    deleteDocument = async (id: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete',
            data: { id },
        }, true);
        return this;
    }
    //--------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES CAMBIA EL ESTADO DE UNA PARADA
     * @EN CHANGES THE STATE OF A PARADA
     * 
     * @param stopId
     * @param statusId
     */
    // -------------------------------------------------------------------------------------------------------------
    changeStatusDocument = async (documentId: string, statusId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/change-status',
            data: { 
                id: documentId,
                statusId: statusId
            },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    //--------------------------------------------------------------------------------------------------------
    /**
     * @ES EDITAR DOCUMENTO
     * @EN EDIT DOCUMENT
     * 
     * @param values
     */
    //--------------------------------------------------------------------------------------------------------
    editDocument = async (values: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/edit',
            data: values,
            headers: { "Content-Type": "multipart/form-data" }
        }, true);
        return this;
    }
    //--------------------------------------------------------------------------------------------------------


    //--------------------------------------------------------------------------------------------------------
    /**
     * @ES GENERAR INFORME PERSONALIZADO
     * @EN GENERATE CUSTOM REPORT
     * 
     * @param filters
     */
    generateCustomReport = async (filters: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/generate-custom-report',
            data: filters,
        }, true);
        return this;
    }
    //--------------------------------------------------------------------------------------------------------


    //--------------------------------------------------------------------------------------------------------
    /**
     * @ES LISTAR INFORME PERSONALIZADO
     * @EN LISTAR CUSTOM REPORT
     * 
     * @param filters
     */
    listCustomReports = async (filters: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list-custom-reports',
            data: filters,
        }, true);
        return this;
    }
    //--------------------------------------------------------------------------------------------------------



    //--------------------------------------------------------------------------------------------------------
    /**
     * @ES LISTAR ESTADOS PARA SELECT
     * @EN LIST STATUS FOR SELECT`
     * 
     * @param filters
     */
    listForSelectStatus = async (filters: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list-select-status',
            data: filters,
        }, true);
        return this;
    }
    //--------------------------------------------------------------------------------------------------------

        //--------------------------------------------------------------------------------------------------------
    /**
     * @ES LISTAR TIPOS PARA SELECT
     * @EN LIST TYPES FOR SELECT
     * 
     * @param filters
     */
    listForSelectTypes = async (filters: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list-select-types',
            data: filters,
        }, true);
        return this;
    }
    //--------------------------------------------------------------------------------------------------------
}